<template>
    <div class="FeedBack">
        <div class="titlePage">Formulario de Monitoreo {{this.feedbackArea}}</div>
         <modal
            name="FeedBackModal"
            width="50%"
            height="auto"
            :scrollable="true"
            :adaptive="true"
            :clickToClose="false"
            style="overflow:scroll"
        >
            <div class="dataInternal">
                <va-notification color="danger" v-if="refNoArea" class="refNoData">No tiene permisos para generar una retroalimentación a nuestros asesores.</va-notification>
                <ValidationObserver ref="obsFieldsArea">
                    <FormAreaSelect
                        :FieldsForm="AreaForm"
                        :ModelForm="AreaModelForm"
                        :method="executeProcess"
                        v-if="renderComponent3"
                    />
                </ValidationObserver>
            </div>
        </modal>
        <va-notification color="danger" v-if="refNoData" class="refNoData">Se presento un fallo al momento de procesar el monitoreo.</va-notification>
        <va-notification color="danger" v-if="refNoArea" class="refNoData">No tiene permisos para generar una retroalimentación a nuestros asesores.</va-notification>
        <va-notification color="info" v-if="refAddFeed" class="refNoData">Se realizo el monitoreo correctamente.</va-notification>
        <div v-if="refAddFeedFile" class="pdfView">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <pdf v-for="i in this.numPages" :key="i" :src="UriFile" :page="i" style="padding-bottom: 10px;"></pdf>
            </div>
            <div class="col-md-1">
              <div class="listPdf row">
                <div class="col-md-12"><img class="imgdata" src="../../assets/images/AddFeed.png" title="Nuevo Monitoreo" alt="Nuevo Monitoreo" width="40" @click="loadFormNew" /></div>
                <div class="col-md-12"><img class="imgdata" v-if="this.RolArea === 'SUP'" src="../../assets/images/EditFeed.png" title="Editar" alt="Editar" width="40" @click="loadFormEdit" /></div>
                <div class="col-md-12"><img class="imgdata" src="../../assets/images/PrintFeed.png" title="Imprimir" alt="Imprimir" width="40" @click="printDocument" /></div>
              </div>
            </div>
          </div>
        </div>
        <div class="listData" v-if="formList">
            <div class="row">
              <div class="col-md-8">
                <va-notification color="warning">
                <div>
                    <h3>Por favor tener en cuenta el modelo de evaluación:</h3>
                    <li>100%: es cuando aplica el Item de forma Positiva.</li>
                    <li>0%: es cuando aplica el item de forma Negativa.</li>
                    <li>No aplica: se deja el campo vacio y no se afecta.</li>
                    <li class="alertInfo">Todo Error requiere Feedback (retroelimentación por el Auditor).</li>
                </div>
                </va-notification>
              </div>
              <div class="col-md-4">
                <button id="loadFormNew" type="submit" v-on:click="loadFormNew" class="loginbtn primaryBtn">Nuevo Monitoreo</button>
                <button id="loadForm" type="submit" v-on:click="updateForm" class="loginbtn primaryBtn" v-if="this.$route.params.idArea">Actualizar Monitoreo</button>
                <button id="loadForm" type="submit" v-on:click="sendForm" class="loginbtn primaryBtn" v-else>Guardar Monitoreo</button>
              </div>
            </div>
          <div class="formPage">
              <ValidationObserver ref="obsFieldsFiles">
                  <FormFeedBack :FieldsForm="listFormFeedBackBase" :ModelForm="listFormFeedBackModelBase" :method="executeProcess" v-if="renderComponent1" />
                  <FormFeedBack :FieldsForm="listFormFeedBack" :ModelForm="listFormFeedBackModel" :method="executeProcess" v-if="renderComponent2" />
              </ValidationObserver>
          </div>
          <div class="row">
            <div class="col-md-8">
            </div>
            <div class="col-md-4">
              <button id="loadForm" type="submit" v-on:click="updateForm" class="loginbtn primaryBtn" v-if="this.$route.params.idArea">Actualizar Monitoreo</button>
              <button id="loadForm" type="submit" v-on:click="sendForm" class="loginbtn primaryBtn" v-else>Guardar Monitoreo</button>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
// eslint-disable-next-line import/no-duplicates
import FormAreaSelect from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormFeedBack from '@/components/forms/Forms.vue'
import pdf from 'vue-pdf'

export default {
  name: 'FeedBack',
  components: {
    FormAreaSelect,
    FormFeedBack,
    pdf,
  },
  data () {
    return {
      numPages: 1,
      refNoData: false,
      UriFile: '',
      formList: false,
      renderComponent3: false,
      renderComponent2: false,
      renderComponent1: false,
      refAddFeed: false,
      refAddFeedFile: false,
      refNoArea: false,
      datFeedBack: [],
      editFeedBack: [],
      listFormFeedBack: [],
      listFormFeedBackBase: [],
      editForm: {},
      listFormFeedBackModel: {},
      listFormFeedBackModelBase: {},
      ListArea: [],
      RolArea: '',
      AreaModelForm: {
        IdSelectArea: '',
      },
      AreaForm: [
        {
          id: 'titleArea',
          name: 'Seleccione el area donde realizara la retroalimentación',
          type: 'title',
          class: 'col-md-12',
        },
        {
          id: 'IdSelectArea',
          model: 'IdSelectArea',
          name: 'Seleccione Area',
          type: 'Select',
          placeholder: 'Seleccione Area',
          class: 'col-md-12',
          values: [],
          validate: {
            required: true,
          },
        },
        {
          id: 'Cancel_Button',
          type: 'button',
          placeholder: 'Cancelar',
          class: 'col-md-6',
        },
        {
          id: 'Area_Button',
          type: 'button',
          placeholder: 'Seleccionar',
          class: 'col-md-6',
        },
      ],
      feedbackArea: '',
    }
  },
  methods: {
    loadFormEdit () {
      this.$loading.show()
      window.location.replace(window.location.origin + '/admin/FeedBackForm/' + this.editForm.idFeedBack + '/' + this.ListArea[this.AreaModelForm.IdSelectArea].IdArea)
    },
    printDocument () {
      window.open(this.UriFile, '_blank')
    },
    updateForm () {
      if (this.validateForm()) {
        this.$refs.obsFieldsFiles.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 0)
          } else {
            if (this.RolArea === 'SUP') {
              let message = {
                title: 'Actualización - Roles y Permisos',
                body: '¿ Se realizará la actualización del monitoreo realizado al asesor "' + this.listFormFeedBackModel['FPV_NASE'] + '", está seguro de realizar esta actualización ?',
              }
              let options = {
                okText: 'Continuar',
                cancelText: 'Cancelar',
              }
              this.$dialog.confirm(message, options).then(dialog => {
                this.sendForm()
              })
            } else {
              this.refNoArea = true
            }
          }
          return true
        })
      }
    },
    sendForm () {
      var sendinfo = true
      if (this.$route.params.idMonitor === undefined) {
        sendinfo = this.validateForm()
      }
      if (sendinfo === true) {
        return new Promise((resolve, reject) => {
          this.refAddFeed = false
          this.refAddFeedFile = false
          this.refNoData = false
          this.$refs.obsFieldsFiles.validate().then(results => {
            if (!results) {
              IberoHelpers.scrollToTop(0, 0)
              resolve(false)
            } else {
              for (const itemsSend in this.listFormFeedBackModelBase) {
                this.listFormFeedBackModel[itemsSend] = this.listFormFeedBackModelBase[itemsSend]
              }
              var processform = 1
              let loader = this.$loading.show()
              if (!(this.$route.params.idArea === undefined)) {
                processform = 4
                this.listFormFeedBackModel['Id_Person_Update'] = this.$session.get('IberoJWTAdminLogin').idPerson
                this.listFormFeedBackModel['Id_Person_Audit'] = this.listFormFeedBackModel['Id_Person_Audit']
              } else {
                this.listFormFeedBackModel['Id_Person_Audit'] = this.$session.get('IberoJWTAdminLogin').idPerson
              }
              this.listFormFeedBackModel.Id_Area = this.ListArea[this.AreaModelForm.IdSelectArea].IdArea
              this.listFormFeedBackModel.Id_Mail = 0
              this.listFormFeedBackModel.Id_Monitoring = 0

              var refMail = this.ListArea[this.AreaModelForm.IdSelectArea].TemplatesByArea.find(function (element) {
                return element.TypeTemplate === 'MAIL'
              }).Cod_Template
              var refPDF = this.ListArea[this.AreaModelForm.IdSelectArea].TemplatesByArea.find(function (element) {
                return element.TypeTemplate === 'PDF'
              }).Cod_Template

              var refCA = this.listFormFeedBackModelBase['FPV_CA'].split('|')
              this.listFormFeedBackModel['FPV_CA'] = refCA[0].trim()
              var ccdocAudit = this.listFormFeedBackModel['FPV_CA']
              var infAuditor = this.datFeedBack.AsesorsAudit.find(function (element) {
                return element.DocAudit === ccdocAudit
              })
              this.listFormFeedBackModel['FPV_NASE'] = infAuditor.FirstNameAudit + ' ' + infAuditor.LastNameAudit
              this.listFormFeedBackModel['Id_Person_Assessor'] = infAuditor.IdAudit

              if (this.RolArea === 'SUP' && this.listFormFeedBackModelBase['FPV_CAUDIT'] !== 0) {
                var refCAudit = this.listFormFeedBackModelBase['FPV_CAUDIT'].split('|')
                var IdPersonCAudit = this.datFeedBack.SupervisorsAudit.find(function (element) {
                  return element.DocAudit.toString() === refCAudit[0].trim().toString()
                }).IdAudit
                this.listFormFeedBackModel['FPV_CAUDIT'] = IdPersonCAudit
              } else {
                this.listFormFeedBackModel['FPV_CAUDIT'] = this.listFormFeedBackModelBase['FPV_CAUDIT']
              }
              this.listFormFeedBackModel['FPV_FT'] = new Date(this.listFormFeedBackModel['FPV_FT'])
              this.listFormFeedBackModel['FPV_FT'] = this.listFormFeedBackModel['FPV_FT'].toLocaleDateString()
              var addFeedBack = IberoHelpers.addDataFeedBack(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson, processform, refMail, refPDF, this.listFormFeedBackModel)
              addFeedBack.then(Response => {
                IberoHelpers.scrollToTop(0, 0)
                if (Response.data) {
                  this.editForm = Response.data
                  var fileUri = JSON.parse(Response.data.detailFile)
                  this.UriFile = fileUri[0].Det_URI + fileUri[0].Nam_File
                  this.refAddFeed = true
                  try {
                    var myFile = new XMLHttpRequest()
                    myFile.open('HEAD', this.UriFile, false)
                    myFile.send()
                    if (myFile.status === 200) {
                      this.srcFile = pdf.createLoadingTask(this.UriFile)
                      this.srcFile.promise.then(pdfFile => {
                        this.numPages = pdfFile.numPages
                        this.refAddFeedFile = true
                      })
                    }
                  } catch (error) {
                    this.refAddFeedFile = false
                  }
                  this.formList = false
                  resolve(true)
                } else {
                  this.refNoData = true
                  resolve(false)
                }
                loader.hide()
              })
            }
          })
        })
      }
    },
    setObjectlist (valorum) {
      var DataArray = ''
      var infolist = []
      DataArray = valorum.split('|')
      for (var i = 0; i < DataArray.length; i++) {
        infolist.push(
          { id: DataArray[i], value: DataArray[i] }
        )
      }
      return infolist
    },
    validateForm () {
      var resulVal = true
      if (this.RolArea === 'SUP' && this.listFormFeedBackModelBase['FPV_CAUDIT'] !== 0) {
        var refCAudit = this.listFormFeedBackModelBase['FPV_CAUDIT'].split('|')
        var IdPersonCAudit = this.datFeedBack.SupervisorsAudit.find(function (element) {
          return element.DocAudit.toString() === refCAudit[0].trim().toString()
        })
        if (IdPersonCAudit === undefined) {
          this.listFormFeedBackModelBase['FPV_CAUDIT'] = ''
          resulVal = false
        }
      }

      var refCA = this.listFormFeedBackModelBase['FPV_CA'].split('|')
      this.listFormFeedBackModelBase['FPV_CA'] = refCA[0].trim()
      var ccdocAudit = this.listFormFeedBackModelBase['FPV_CA']
      var infAuditor = this.datFeedBack.AsesorsAudit.find(function (element) {
        return element.DocAudit === ccdocAudit
      })

      if (infAuditor === undefined) {
        this.listFormFeedBackModelBase['FPV_CA'] = ''
        resulVal = false
      }
      this.$refs.obsFieldsFiles.validate()
      return resulVal
    },
    loadFormNew () {
      this.$loading.show()
      window.location.replace(window.location.origin + '/admin/FeedBackForm')
    },
    loadForm () {
      this.listFormFeedBack.length = 0
      for (var i = 0; i < this.datFeedBack.FormFeedBack.length; i++) {
        var validateRef = ''
        var validatePicker = {}
        var listData = ''
        var refRegis = this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm
        var Datplaceholder = this.datFeedBack.FormFeedBack[i].Nam_FeedBackForm

        if (this.datFeedBack.FormFeedBack[i].Det_ValidateFeedBackForm !== '') {
          validateRef = JSON.parse(this.datFeedBack.FormFeedBack[i].Det_ValidateFeedBackForm)
        }

        if (this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_NA') {
          listData = this.datFeedBack.FirstNameAudit + ' ' + this.datFeedBack.LastNameAudit
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = this.datFeedBack.FirstNameAudit + ' ' + this.datFeedBack.LastNameAudit
          } else {
            this.listFormFeedBackModel[refRegis] = this.datFeedBack.FirstNameAudit + ' ' + this.datFeedBack.LastNameAudit
          }
        } else if (this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_CA' || this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_CAUDIT') {
          if (!(this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm] === undefined)) {
            var ListAsesor = []
            for (var k = 0; k < this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm].length; k++) {
              var infoAsesor = this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm][k].DocAudit + ' | ' + this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm][k].FirstNameAudit + ' ' + this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm][k].LastNameAudit
              var idref = this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_CA' ? this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm][k].DocAudit : this.datFeedBack[this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm][k].IdAudit
              ListAsesor.push(
                { id: idref.toString(), value: infoAsesor }
              )
            }
            listData = ListAsesor
            if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
              this.listFormFeedBackModelBase[refRegis] = ''
            } else {
              this.listFormFeedBackModel[refRegis] = ''
            }

            if (this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_CA' && this.$route.params.idMonitor !== undefined) {
              var ccdocAudit = this.datFeedBack.EditFeedBack[0]['FPV_CA']
              var infAuditor = this.datFeedBack.AsesorsAudit.find(function (element) {
                return element.DocAudit === ccdocAudit
              })
              Datplaceholder = infAuditor === undefined ? Datplaceholder : infAuditor.DocAudit + ' | ' + infAuditor.FirstNameAudit + ' ' + infAuditor.LastNameAudit
            }

            if (this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_CAUDIT') {
              if (!(this.RolArea === 'SUP')) {
                refRegis = 0
              } else if (!(this.$route.params.idMonitor === undefined)) {
                if (this.datFeedBack.EditFeedBack[0]['FPV_CAUDIT'] === 0) {
                  refRegis = 0
                } else {
                  var idAse = this.datFeedBack.EditFeedBack[0]['FPV_CAUDIT']
                  var infAse = this.datFeedBack.SupervisorsAudit.find(function (element) {
                    return element.IdAudit === idAse
                  })
                  Datplaceholder = infAse === undefined ? idAse : infAse.DocAudit + ' | ' + infAse.FirstNameAudit + ' ' + infAse.LastNameAudit
                }
              }
            }
          }
        } else if (this.datFeedBack.FormFeedBack[i].Cod_FeedBackForm === 'FPV_FA') {
          listData = IberoHelpers.dataObjDate(Date())
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = listData
          } else {
            this.listFormFeedBackModel[refRegis] = listData
          }
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'radio' || this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'Select') {
          listData = this.setObjectlist(this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm)
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = this.datFeedBack.FormFeedBack[i].Det_FeedBackForm
          } else {
            this.listFormFeedBackModel[refRegis] = this.datFeedBack.FormFeedBack[i].Det_FeedBackForm
          }
          if (this.datFeedBack.FormFeedBack[i].Det_FeedBackForm !== '') {
            Datplaceholder = ''
          }
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'datepicker') {
          if (this.datFeedBack.EditFeedBack !== undefined) {
            var dateparts = this.datFeedBack.EditFeedBack[0].FPV_FT.split('-').map((d) => parseInt(d))
            this.datFeedBack.EditFeedBack[0].FPV_FT = new Date(
              dateparts[0] + '/' + dateparts[1] + '/' + dateparts[2]
            )
          }
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = ''
          } else {
            this.listFormFeedBackModel[refRegis] = ''
          }
          validatePicker.format = this.$store.state.dateFormat
          validatePicker.disabledDates = {
            to: new Date(1900, 0, 1),
            from: new Date(),
          }
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'title') {
          validatePicker = null
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'summary') {
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm
          } else {
            this.listFormFeedBackModel[refRegis] = this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm
          }
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'accepted') {
          Datplaceholder = this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm
          if (this.datFeedBack.FormFeedBack[i].Sta_AditionalFeedBackForm) {
            this.listHtml.push({ id: 'cbox_' + refRegis, value: this.datFeedBack.FormFeedBack[i].Det_FeedBackForm, show: false })
            Datplaceholder = Datplaceholder.replace('[', '<a class="linkTerm">').replace(']', '</a>')
          }
          listData = 'Si'
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'check') {
          listData = this.setObjectlist(this.datFeedBack.FormFeedBack[i].Det_DataFeedBackForm)
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = []
          } else {
            this.listFormFeedBackModel[refRegis] = []
          }
        } else if (this.datFeedBack.FormFeedBack[i].Type_FeedBackForm === 'textarea') {
          listData = this.datFeedBack.FormFeedBack[i].Det_FeedBackForm
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = ''
          } else {
            this.listFormFeedBackModel[refRegis] = ''
          }
        } else {
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[refRegis] = ''
          } else {
            this.listFormFeedBackModel[refRegis] = ''
          }
        }

        if (refRegis !== 0) {
          if (this.datFeedBack.FormFeedBack[i].Sta_FeedBackView === 1) {
            this.listFormFeedBackBase.push({
              id: refRegis,
              name: this.datFeedBack.FormFeedBack[i].Nam_FeedBackForm,
              type: this.datFeedBack.FormFeedBack[i].Type_FeedBackForm,
              class: this.datFeedBack.FormFeedBack[i].Det_DataFeedBackClass,
              placeholder: Datplaceholder,
              values: listData,
              model: refRegis,
              validate: validateRef,
              dateTimePickerOptions: validatePicker,
              tooltip: this.datFeedBack.FormFeedBack[i].Det_FeedBackTooltip,
              disabled: false,
            })
          } else {
            this.listFormFeedBack.push({
              id: refRegis,
              name: this.datFeedBack.FormFeedBack[i].Nam_FeedBackForm,
              type: this.datFeedBack.FormFeedBack[i].Type_FeedBackForm,
              class: this.datFeedBack.FormFeedBack[i].Det_DataFeedBackClass,
              placeholder: Datplaceholder,
              values: listData,
              model: refRegis,
              validate: validateRef,
              dateTimePickerOptions: validatePicker,
              tooltip: this.datFeedBack.FormFeedBack[i].Det_FeedBackTooltip,
              disabled: false,
            })
          }
        }
      }
      if (this.datFeedBack.EditFeedBack === undefined) {
        this.listFormFeedBackModel['Id_Person_Update'] = 0
      } else {
        this.listFormFeedBackModel['Id_Person_Update'] = this.$session.get('IberoJWTAdminLogin').idPerson
        this.loadDataEdit()
      }
      this.formList = true
      IberoHelpers.forceRerender1(this)
      IberoHelpers.forceRerender2(this)
    },
    loadDataEdit () {
      for (const itemsEdit in this.datFeedBack.EditFeedBack[0]) {
        var valueDat = ''
        if ((itemsEdit.indexOf('ECN_TOTAL') >= 1) || (itemsEdit.indexOf('ECUF_TOTAL') >= 1) || (itemsEdit.indexOf('ECC_TOTAL') >= 1)) {
          valueDat = this.datFeedBack.EditFeedBack[0][itemsEdit]
        } else if ((itemsEdit.indexOf('ECN') >= 1) || (itemsEdit.indexOf('ECUF') >= 1) || (itemsEdit.indexOf('ECC') >= 1)) {
          valueDat = this.datFeedBack.EditFeedBack[0][itemsEdit] === '1' ? '100%' : '0%'
        } else if (itemsEdit === 'FPV_CA') {
          var ccdocAudit = this.datFeedBack.EditFeedBack[0][itemsEdit]
          var infAuditor = this.datFeedBack.AsesorsAudit.find(function (element) {
            return element.DocAudit === ccdocAudit
          })
          valueDat = infAuditor === undefined ? '' : infAuditor.DocAudit + ' | ' + infAuditor.FirstNameAudit + ' ' + infAuditor.LastNameAudit
        } else if (itemsEdit === 'FPV_CAUDIT') {
          var idAse = this.datFeedBack.EditFeedBack[0][itemsEdit]
          var infAse = this.datFeedBack.SupervisorsAudit.find(function (element) {
            return element.IdAudit === idAse
          })
          valueDat = infAse === undefined ? idAse : infAse.DocAudit + ' | ' + infAse.FirstNameAudit + ' ' + infAse.LastNameAudit
        } else {
          valueDat = this.datFeedBack.EditFeedBack[0][itemsEdit]
        }

        var refModel = this.datFeedBack.FormFeedBack.find(function (element) {
          return element.Cod_FeedBackForm === itemsEdit
        })

        if (!(refModel === undefined)) {
          if (refModel.Sta_FeedBackView === 1) {
            this.listFormFeedBackModelBase[itemsEdit] = valueDat
          } else {
            this.listFormFeedBackModel[itemsEdit] = valueDat
          }
        } else {
          this.listFormFeedBackModel[itemsEdit] = valueDat
        }
      }
      return true
    },
    validateRol () {
      var refRolArea = this.ListArea[this.AreaModelForm.IdSelectArea].RolByArea.find(function (element) {
        return element.Cod_Role === 'SUP' || element.Cod_Role === 'AUD'
      })
      if (refRolArea === undefined) {
        this.refNoArea = true
      } else {
        this.feedbackArea = this.ListArea[this.AreaModelForm.IdSelectArea].NamArea
        this.RolArea = refRolArea.Cod_Role
        this.$modal.hide('FeedBackModal')
        this.callDataForm()
      }
    },
    executeProcess: function (event, refer) {
      switch (event.target.id) {
        case 'div_FPV_CAUDIT':
        case 'div_FPV_CA':
          var idValue = event.target.id.split('div_')[1]
          if (!(this.$route.params.idMonitor === undefined)) {
            this.listFormFeedBackModel[idValue] = event.target.event.target.placeholder
          } else {
            this.listFormFeedBackModel[idValue] = ''
          }
          break
        case 'btn_Area_Button':
          this.$refs.obsFieldsArea.validate().then(results => {
            if (results) {
              this.validateRol()
            }
          })
          break
        case 'btn_Cancel_Button':
          this.$router.push('admin/')
          break
        default:
          var sumarValue = event.target.id.split('_')
          if (sumarValue.length === 3) {
            var idModelSum = sumarValue[0] + '_' + sumarValue[1]
            var idModelTotal = sumarValue[0] + '_' + sumarValue[1] + '_TOTAL'
            this.listFormFeedBackModel[idModelTotal] = 0
            let vallistPass = 1
            for (var [key, value] of Object.entries(this.listFormFeedBackModel)) {
              if (key.includes(idModelSum) >= 1 && key !== idModelTotal && sumarValue[1] !== 'ENC' && (value === '0%' || value === '')) {
                vallistPass = 0
              } else if (key.includes(idModelSum) >= 1 && key !== idModelTotal && sumarValue[1] === 'ENC') {
                if (value === '') { value = 0 }
                this.listFormFeedBackModel[idModelTotal] = parseInt(this.listFormFeedBackModel[idModelTotal]) + parseInt(value)
              }
            }
            if (vallistPass === 1 && sumarValue[1] !== 'ENC') {
              this.listFormFeedBackModel[idModelTotal] = '100%'
            } else if (vallistPass === 0 && sumarValue[1] !== 'ENC') {
              this.listFormFeedBackModel[idModelTotal] = '0%'
            }
            IberoHelpers.forceRerender2(this)
          }
          break
      }
    },
    callDataForm () {
      let loaderForm = this.$loading.show()
      var idedit = this.$route.params.idMonitor === undefined ? 0 : this.$route.params.idMonitor
      var datForm = IberoHelpers.getAreaFormByPerson(this.$store, this.ListArea[this.AreaModelForm.IdSelectArea].IdArea, this.RolArea, this.$session.get('IberoJWTAdminLogin').idPerson, idedit)
      datForm.then(Response => {
        if (Response.data) {
          this.datFeedBack = Response.data[0]
          this.loadForm()
          this.renderComponent3 = false
          loaderForm.hide()
        }
      })
    },
    loadTypeForm () {
      this.refNoArea = false
      let loader = this.$loading.show()
      var datArea = IberoHelpers.getAreaByPerson(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson, 'FEEDBACK')
      datArea.then(Response => {
        if (Response.data) {
          this.ListArea = Response.data
          if (!(this.$route.params.idArea === undefined)) {
            var idareaget = this.$route.params.idArea
            var refRolArea = this.ListArea.findIndex(function (element) {
              return parseInt(element.IdArea) === parseInt(idareaget)
            })
            this.AreaModelForm.IdSelectArea = refRolArea
            this.validateRol()
          } else if (Response.data.length > 1) {
            for (var i = 0; i < Response.data.length; i++) {
              this.AreaForm[1].values.push(
                { id: i, value: Response.data[i].NamArea }
              )
            }
            IberoHelpers.forceRerender3(this)
            this.$modal.show('FeedBackModal')
          } else {
            this.AreaModelForm.IdSelectArea = 0
            this.validateRol()
          }
        } else {
          this.refNoArea = true
        }
        loader.hide()
      })
    },
  },
  created: function () {
    this.loadTypeForm()
  },
}
</script>

<style scoped>
.dataInternal{
    padding: 20px;
    margin: 20px;
}

ul {
  padding: 20px;
}

ul li {
   list-style-type: square;
  margin: 5px;
}

.alertInfo {
  color: #a2273c;
}

.loginbtn {
  width: 100% !important;
}

.pdfView{
  padding-top: 20px;
}

.imgdata {
  float: right;
  padding: 2px;
}

.listPdf{
  padding-top: 20px;
}
</style>